// extracted by mini-css-extract-plugin
module.exports = {"container":"nclGJ","header":"_2ht__","link":"_20K3O","list":"_1PKZr"};